var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPincel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5178 1.87441C17.8077 1.58449 18.1519 1.35452 18.5307 1.19762C18.9095 1.04072 19.3155 0.959961 19.7255 0.959961C20.1355 0.959961 20.5415 1.04072 20.9203 1.19762C21.2991 1.35452 21.6432 1.58449 21.9331 1.87441C22.2231 2.16433 22.453 2.50851 22.6099 2.8873C22.7668 3.2661 22.8476 3.67209 22.8476 4.08209C22.8476 4.49209 22.7668 4.89808 22.6099 5.27688C22.453 5.65567 22.2231 5.99985 21.9331 6.28977L7.03132 21.1916L0.960205 22.8474L2.61596 16.7762L17.5178 1.87441Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPincel);
export default __webpack_public_path__ + "static/media/pincel.3f72539210c501be571546d873e5a61d.svg";
export { ForwardRef as ReactComponent };